<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-01-12 10:21:01
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-12 10:21:08
 * @FilePath: /chaoyongtuan/src/views/shopManage/components/extensionDrawer/tableCell/promtionCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="flex flex-align-center">
			<div :class="['state_icon', row.other_status == '1' ? 'success' : 'danger']"></div>
			<div class="ml-10 ml-6">{{ row.other_status_desc || row.promote_status_name }}</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.state_icon {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}
.success {
	background-color: @color-success;
}
.danger {
	background-color: @color-danger;
}
</style>